module.exports = __webpack_public_path__ + "static/img/invitedetail.92a51b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/invitedetail.jpg
// module id = WS0L
// module chunks = 1